import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconName", "onClick", "children"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { EmbersLink, useLinkAriaLabel } from './link';
import { StyledLinkButton } from './linkStyles';
import { onEnterKeyPress } from '../utils/wcagUtils';
export var EmbersButtonLink = function EmbersButtonLink(_ref) {
  var iconName = _ref.iconName,
    onClick = _ref.onClick,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _otherProps$mode = otherProps.mode,
    mode = _otherProps$mode === void 0 ? 'white' : _otherProps$mode,
    _otherProps$size = otherProps.size,
    size = _otherProps$size === void 0 ? 'medium' : _otherProps$size,
    loading = otherProps.loading,
    disabled = otherProps.disabled;
  var ariaLabel = useLinkAriaLabel({
    target: otherProps['target'],
    'aria-label': otherProps['aria-label'],
    children: children
  });
  return iconName ? /*#__PURE__*/React.createElement(StyledLinkButton, _extends({
    role: "button",
    mode: mode,
    size: size,
    className: classnames('EmbersButtonLink', {
      'EmbersButtonLink-disabled': disabled
    }),
    tabIndex: 0,
    onClick: disabled || loading ? undefined : function (e) {
      return onClick === null || onClick === void 0 ? void 0 : onClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, onClick);
    },
    "aria-label": ariaLabel
  }, otherProps), !loading && /*#__PURE__*/React.createElement("span", {
    className: classnames('EmbersButtonLink-icon', iconName)
  }), /*#__PURE__*/React.createElement(EmbersLink, _extends({
    tabIndex: -1,
    role: "none",
    "aria-label": undefined
  }, otherProps, {
    onClick: void 0
  }), children)) : /*#__PURE__*/React.createElement(EmbersLink, _extends({
    onClick: onClick,
    href: void 0,
    component: "button"
  }, otherProps), children);
};